// Styles
import { atQuery } from "../../scripts/components/mediaQueries";
import { headerHeight } from "../../scripts/helpers";
import "./template-product.scss";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest(".shopify-section");
  if (!templateProductSection) return;

  const productMeta = templateProductSection.querySelector(".product__meta");
  const productForm = templateProductSection.querySelector(".product__form");
  const optionWrapper = productForm.querySelector(".product__form__option");
  const toggle = productForm.querySelector(".product__form__option__title");
  const fieldset = productForm.querySelector("fieldset");

  const toggleOptions = () => {
    toggle.classList.toggle("open");
    fieldset.classList.toggle("open");

    if (optionWrapper && toggle.classList.contains("open")) {
      optionWrapper.focus();
    }
  };

  optionWrapper.addEventListener("blur", () => {
    if (fieldset.classList.contains("open")) {
      toggle.querySelector("label").innerText =
        toggle.querySelector("label").dataset.labelClose;
      toggleOptions();
    }
  });

  productForm
    .querySelector(".product__form__option__title")
    .addEventListener("click", () => {
      toggleOptions();
      if (
        productForm
          .querySelector(".product__form__option__title")
          .classList.contains("open")
      ) {
        productForm.querySelector(
          ".product__form__option__title label"
        ).innerText = productForm.querySelector(
          ".product__form__option__title label"
        ).dataset.labelOpen;
      } else {
        productForm.querySelector(
          ".product__form__option__title label"
        ).innerText = productForm.querySelector(
          ".product__form__option__title label"
        ).dataset.labelClose;
      }
    });

  productForm
    .querySelectorAll(".product__form__option__toggle")
    .forEach((toggle) => {
      const fieldset = toggle.closest("fieldset");
      if (!fieldset) return;

      const errorWrapper = templateProductSection.querySelector(
        `[data-fieldset="${fieldset.id}"]`
      );
      if (errorWrapper) {
        fieldset.addEventListener("change", () => {
          errorWrapper.removeAttribute("data-not-updated");
        });
      }

      toggle.addEventListener("click", () => {
        if (toggle.getAttribute("checked")) return;
        const checkedLabels = fieldset.querySelectorAll("label[checked]");
        checkedLabels.forEach((label) => {
          label.removeAttribute("checked");
        });
        toggle.setAttribute("checked", "");
        productForm.querySelector(
          ".product__form__option__title label"
        ).innerText = toggle.outerText;
        productForm.querySelector(
          ".product__form__option__title label"
        ).dataset.labelClose = toggle.outerText;
        toggleOptions();
        productForm
          .querySelector(".btn__add-to-cart")
          .classList.remove("disabled");
      });
    });

  productForm
    .querySelector(".product__form__submit")
    .addEventListener("click", (e) => {
      if (!e.target.classList.contains("disabled")) {
        return;
      }

      e.preventDefault();
    });

  const soldOutTag = productMeta.querySelector(".product__meta__tag--sold-out");
  const saleTag = productMeta.querySelector(".product__meta__tag--sale");
  const generalTag = productMeta.querySelector(
    ".product__meta__tag:not(.product__meta__tag--sale):not(.product__meta__tag--sold-out)"
  );

  const productVariants = templateProductSection.querySelector(
    ".product__meta__variants"
  );
  if (productVariants) {
    new Swiper(productVariants, {
      loop: false,
      slideWidth: "90px",
      freeMode: true,
      slidesPerView: "auto",
      navigation: {
        prevEl: productVariants.querySelector(
          ".product__meta__variants__arrow--left"
        ),
        nextEl: productVariants.querySelector(
          ".product__meta__variants__arrow--right"
        ),
      },
    });
  }

  $(context).on("variantChange", (e) => {
    if (!e || !e.variant) return;
    templateProductSection.querySelectorAll('.swym-add-to-wishlist-view-product').forEach(wishlistButton => {
      if (wishlistButton.dataset.variantId == e.variant.id.toString()) {
        wishlistButton.classList.add('active');
      } else {
        wishlistButton.classList.remove('active');
      }
    });

    if (!e.variant.available && soldOutTag) {
      soldOutTag.classList.add("active");
      saleTag.classList.remove("active");
      if (generalTag) {
        generalTag.classList.remove("active");
      }
    } else if (
      e.variant.price &&
      e.variant.compare_at_price &&
      e.variant.price != e.variant.compare_at_price
    ) {
      productMeta.querySelector(
        'input[name="properties[_compare_at_price]"]'
      ).value = e.variant.compare_at_price;
      if (saleTag) {
        soldOutTag.classList.remove("active");
        saleTag.classList.add("active");
        if (generalTag) {
          generalTag.classList.remove("active");
        }
      } else if (generalTag) {
        soldOutTag.classList.remove("active");
        saleTag.classList.remove("active");
        generalTag.classList.add("active");
      }
    } else {
      productMeta.querySelector(
        'input[name="properties[_compare_at_price]"]'
      ).value = "";
      if (
        productForm
          .querySelector(".product__form__submit .btn__add-to-cart")
          .classList.contains("disabled")
      ) {
        productForm
          .querySelector(".product__form__submit .btn__add-to-cart")
          .classList.remove("disabled");
      }
    }
  });

  const productAccordions = context.querySelector(".product__meta__accordions");
  productAccordions
    .querySelector(".product__meta__accordions__titles__title")
    .classList.add("active");
  productAccordions
    .querySelector(".product__meta__accordions__contents__content")
    .classList.add("active");

  productAccordions
    .querySelectorAll(".product__meta__accordions__titles__title")
    .forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
        if (accordionTitle.classList.contains("active")) {
          return;
        }

        productAccordions
          .querySelector(".product__meta__accordions__titles__title.active")
          .classList.remove("active");
        productAccordions
          .querySelector(".product__meta__accordions__contents__content.active")
          .classList.remove("active");

        productAccordions
          .querySelector(
            `.product__meta__accordions__titles__title[data-accordion="${accordionTitle.dataset.accordion}"]`
          )
          .classList.add("active");
        productAccordions
          .querySelector(
            `.product__meta__accordions__contents__content[data-accordion="${accordionTitle.dataset.accordion}"]`
          )
          .classList.add("active");
      });
    });

  const pageContainer = document.querySelector(
    "html.template-product #PageContainer"
  );
  const mediaContainer = document.querySelector(".product-gallery--mobile");
  const hammerOpener = templateProductSection.querySelector(
    ".product__dock-trigger"
  );
  const hammerContainer = templateProductSection.querySelector(
    ".product__dock-container"
  );
  const hammerOpenerFromGallery = mediaContainer.querySelector(
    ".product-gallery .product__dock-gallery-trigger"
  );
  const mainInfo = templateProductSection.querySelector(
    ".product__meta__heading--info"
  );

  atQuery("min", "lg", () => {
    if (pageContainer) {
      pageContainer.style.maxHeight = "";
      pageContainer.style.minHeight = "";
      pageContainer.style.transform = "";
    }

    if (mediaContainer) {
      mediaContainer.style.paddingBottom = "";
    }
  });

  atQuery("max", "lg", () => {
    var offset = hammerContainer ? hammerContainer.clientHeight : 0;
    offset += mainInfo ? mainInfo.clientHeight : 0;

    if (pageContainer) {
      pageContainer.style.maxHeight = `calc(100dvh - ${headerHeight()}px)`;
      pageContainer.style.minHeight = `calc(100dvh - ${headerHeight()}px)`;
      pageContainer.style.transform = `translateY(calc(100% - ${offset}px))`;
    }

    if (mediaContainer) {
      mediaContainer.style.paddingBottom = `${offset}px`;
    }
  });

  const hammerJs = new Hammer(hammerOpener, {
    recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_VERTICAL }]],
  });

  const hammerJsGallery = new Hammer(hammerOpenerFromGallery, {
    recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_VERTICAL }]],
  });

  function slideHammer(hammerJs) {
    hammerJs.on("pan", (ev) => {
      window.requestAnimationFrame(() => {
        if (
          document
            .querySelector("html.template-product")
            .classList.contains("open-details")
        ) {

          let deltaHeaderHeight = headerHeight() + ev.deltaY;
          if(deltaHeaderHeight <= 0){
             deltaHeaderHeight = headerHeight();
          }
          pageContainer.style.transform = `translateY(calc(100% - 100dvh + ${
            deltaHeaderHeight
          }px))`;

          if(!document.querySelector('.top-arrow__wrapper').classList.contains('visible')){
            pageContainer.style.overflow = `revert`;
          }

        } else {
          var offset = hammerContainer ? hammerContainer.clientHeight : 0;
          offset += mainInfo ? mainInfo.clientHeight : 0;
          pageContainer.style.transform = `translateY(calc(100% - ${offset}px - ${
            ev.deltaY * -1
          }px))`;

          pageContainer.style.overflow = `auto`;
        }
      });
    });
  }

  function openHammer(hammerJs) {
    hammerJs.on("panend", (ev) => {
      pageContainer.style.transition = "transform 250ms ease-out";
      window.requestAnimationFrame(() => {
        window.setTimeout(function () {
          if (
            document
              .querySelector("html.template-product")
              .classList.contains("open-details")
          ) {
            if (ev.deltaY < window.innerHeight / 4) {
              pageContainer.style.transform = `translateY(calc(100% - 100dvh + ${headerHeight()}px))`;
            } else {
              var offset = hammerContainer ? hammerContainer.clientHeight : 0;
              document
                .querySelector("html.template-product")
                .classList.remove("open-details");
              offset += mainInfo ? mainInfo.clientHeight : 0;
              pageContainer.style.transform = `translateY(calc(100% - ${offset}px))`;
              pageContainer.addEventListener("transitionend", () => {
                mediaContainer.style.maxHeight = "unset";
              });
            }
          } else {
            if (ev.deltaY * -1 < window.innerHeight / 4) {
              var offset = hammerContainer ? hammerContainer.clientHeight : 0;
              offset += mainInfo ? mainInfo.clientHeight : 0;
              pageContainer.style.transform = `translateY(calc(100% - ${offset}px))`;
            } else {
              document
                .querySelector("html.template-product")
                .classList.add("open-details");
              pageContainer.style.transform = `translateY(calc(100% - 100dvh + ${headerHeight()}px))`;
              pageContainer.addEventListener("transitionend", () => {
                mediaContainer.style.maxHeight = `calc(100dvh - ${headerHeight()}px)`;
              });
            }
          }
        }, 100);
      });
    });
  }

  pageContainer.addEventListener("scroll", () => {
    pageContainer.style.transform = `translateY(calc(100% - 100dvh + ${headerHeight()}px))`;
  });

  pageContainer.addEventListener("transitionend", () => {
    pageContainer.style.transition = "";
  });

  slideHammer(hammerJs);
  slideHammer(hammerJsGallery);

  openHammer(hammerJs);
  openHammer(hammerJsGallery);

  atQuery("max", "lg", () => {
    const selectSizeContainer = document.querySelector(
      ".product__form__submit"
    );
    const addToCartButton = selectSizeContainer.querySelector(
      "button.btn__add-to-cart"
    );
    const selectSize = selectSizeContainer.querySelector(
      ".product-select-variant"
    );

    selectSizeContainer.addEventListener("mousedown", () => {
      if (selectSizeContainer.classList.contains("close")) {
        selectSizeContainer.classList.remove("close");
      }
    });

    const addToCartButtonContent = addToCartButton.innerHTML;

    if (selectSize) {
      selectSize.addEventListener("change", function () {
        let selectContext = this.getAttribute("data-option-select");
        let realSelect = document
          .querySelector(`#${selectContext}`)
          .querySelector(`input[value="${this.value}"`);
        if (realSelect && this.value == realSelect.value) {
          realSelect.click();
          addToCartButton.innerHTML = `${this.value} - ${addToCartButtonContent}`;
          if (!this.classList.contains("selected")) {
            this.classList.add("selected");
          }
        } else {
          addToCartButton.innerHTML = addToCartButtonContent;
        }
      });
    }
  });
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll(".product-template"), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll(".product-template"), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
